import { render, staticRenderFns } from "./FieldChangeBadge.vue?vue&type=template&id=23f9f9a4&"
import script from "./FieldChangeBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./FieldChangeBadge.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports